import axios from "axios";
import { App } from "antd";
import { TOKEN } from "../common/constants";


const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN);
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers["Time-Zone"] = timezone;

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - Handle errors globally with toast messages
http.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const { message } = App.useApp();
    console.error("API Error:", error);

    // Handle different error scenarios
    if (error.response) {
      // Server responded with error status
      const status = error.response.status;
      const errorData = error.response.data;

      switch (status) {
        case 400:
          // Bad Request
          message.error(errorData?.message || "Yêu cầu không hợp lệ. Vui lòng kiểm tra lại thông tin đã nhập.");
          break;

        case 401:
          // Unauthorized - clear auth and redirect to login
          message.error("Phiên đăng nhập của bạn đã hết hạn. Vui lòng đăng nhập lại.");
          localStorage.clear();
          
          if (window.location.pathname !== "/login") {
            setTimeout(() => {
              window.location.href = "/login";
            }, 1500);
          }
          break;

        case 403:
          // Forbidden
          message.error("Bạn không có quyền thực hiện hành động này.");
          break;

        case 404:
          // Not Found
          message.error(errorData?.message || "Không tìm thấy tài nguyên được yêu cầu.");
          break;

        case 422:
          // Validation Error
          if (errorData?.message) {
            // Clean up validation error messages
            const cleanMessage = errorData.message
              .replace(/[{}[\]'"]/g, '') // Remove brackets and quotes
              .replace(/ErrorDetail\(string=/g, '') // Remove ErrorDetail wrapper
              .replace(/code=invalid_choice\)/g, '') // Remove code info
              .split(',')[0]; // Take first error if multiple
            
            message.error(cleanMessage || "Xác thực thất bại. Vui lòng kiểm tra lại thông tin đã nhập.");
          } else if (errorData?.errors) {
            // Handle validation errors object
            const firstError = Object.values(errorData.errors)[0];
            message.error(Array.isArray(firstError) ? firstError[0] : firstError);
          } else {
            message.error("Xác thực thất bại. Vui lòng kiểm tra lại thông tin đã nhập.");
          }
          break;

        case 503:
          // Service Unavailable
          message.error("Dịch vụ hiện tạm thời không khả dụng. Vui lòng thử lại sau.");
          break;

        default:
          // Other errors
          message.error(errorData?.message || `Lỗi: ${status}. Đã xảy ra lỗi.`);
      }
    } else if (error.request) {
      // Request made but no response received (network error)
      message.error("Không nhận được phản hồi từ máy chủ. Vui lòng kiểm tra kết nối internet của bạn.");
    } else {
      // Something else happened
      message.error(error.message || "Đã xảy ra lỗi không mong muốn.");
    }

    return Promise.reject(error);
  }
);

export default http;